import React, { useRef, useState } from 'react'
import { supabase } from '../lib/supabase'
import { videoConfig } from '../config/videos'

const heroVideoUrl = supabase.storage
  .from(videoConfig.bucketName)
  .getPublicUrl(videoConfig.heroVideoPath).data.publicUrl

function Hero() {
  const videoRef = useRef(null)
  const [isMuted, setIsMuted] = useState(true)

  const toggleMute = () => {
    const video = videoRef.current
    if (!video) return
    const next = !video.muted
    video.muted = next
    if (!next) {
      video.play().catch(() => {})
    }
    setIsMuted(next)
  }

  return (
    <section className="hero section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Handyrechnung ganze 10 € senken.<br />
              5 Sekunden Kampagnen.
            </h1>
            <div className="hero-stats">
              <div className="stat">
                <div className="stat-value">0,067€</div>
                <div className="stat-label">pro Kampagne</div>
              </div>
              <div className="stat">
                <div className="stat-value">ganze 10 €</div>
                <div className="stat-label">pro Monat</div>
              </div>
              <div className="stat">
                <div className="stat-value">5 Sek.</div>
                <div className="stat-label">pro Kampagne</div>
              </div>
            </div>
            <div className="hero-cta">
              <a href="#cta" className="btn btn-primary btn-large">
                App herunterladen
              </a>
              <a href="#how-it-works" className="btn btn-secondary btn-large">
                Mehr erfahren
              </a>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-device-mockup">
              <div className="device-frame">
                <div className="device-notch"></div>
                <div className="device-screen">
                  <video
                    ref={videoRef}
                    src={heroVideoUrl}
                    autoPlay
                    loop
                    muted
                    playsInline
                    aria-label="spotx App Demo"
                  />
                  <button
                    type="button"
                    className="video-sound-toggle"
                    onClick={toggleMute}
                    aria-label={isMuted ? 'Ton einschalten' : 'Ton ausschalten'}
                    aria-pressed={!isMuted}
                  >
                    {isMuted ? (
                      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
                        <line x1="23" y1="9" x2="17" y2="15" />
                        <line x1="17" y1="9" x2="23" y2="15" />
                      </svg>
                    ) : (
                      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
                        <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
                        <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
